import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import messages from '../../messages';

import style from './item-quantity.module.less';
import tableStyle from '../../style.module.less';

const ItemQuantityColumnId = 'quantity';

const itemQuantityDataBuilder = (item) => {
  return item[ItemQuantityColumnId];
};

const ItemQuantityCell = ({ value: itemQuantity = 0 }) => {
  return (
    <Text
      className={classnames(style['quantity-text'], {
        [style['is-multiple']]: itemQuantity > 1,
      })}
      element='p'
      textType={TextType.H3}
      value={<FormattedNumber value={itemQuantity ?? 0} />}
    />
  );
};

ItemQuantityCell.propTypes = {
  value: PropTypes.number,
};

const createItemQuantityColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.itemQuantity} />,
  accessor: ItemQuantityColumnId,
  Cell: ItemQuantityCell,
  width: 1,
  className: tableStyle['justify-center'],
});

export { ItemQuantityColumnId, itemQuantityDataBuilder, ItemQuantityCell, createItemQuantityColumnDefinition };
